var render, staticRenderFns
import script from "./BodyInformations.vue?vue&type=script&lang=js"
export * from "./BodyInformations.vue?vue&type=script&lang=js"
import style0 from "./BodyInformations.vue?vue&type=style&index=0&id=0dcc8a10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc8a10",
  null
  
)

export default component.exports